import { Box, IconButton, Stack } from '@mui/material';
import { CardVariant, WsCard, WsTypography, WsTypoVariants } from 'wisestep-base';

import folderIcon from '../../../../images/folderIcon.png';
import googleDrive from '../../../../images/googleDrive.png';
import spreadsheets from '../../../../images/spreadsheets.png';

interface GetCardProps {
  cardIndex: number;
  cardTitle: string;
  cardNavigation: { [key: number]: () => void };
}
const GetCard = ({ cardIndex, cardTitle, cardNavigation }: GetCardProps) => {
  const subTitles = ['Your Device', 'Google Drive', 'Spreadsheets'];
  const uploadIcons = [folderIcon, googleDrive, spreadsheets];
  return (
    <Box mx={2} my={1}>
      <WsCard
        cardType={CardVariant.WITH_OUT_BG}
        title={cardTitle}
        onClick={() => cardNavigation[cardIndex]()}
        middleComponent={
          <Stack direction="column" sx={{ cursor: 'pointer' }} maxHeight="60px">
            <IconButton>
              <img src={uploadIcons[cardIndex]} alt={subTitles[cardIndex]} />
            </IconButton>
            <WsTypography variant={WsTypoVariants.TITLE} bold={true}>
              {subTitles[cardIndex]}
            </WsTypography>
          </Stack>
        }
        isButton={true}
      />
    </Box>
  );
};

export default GetCard;
